'use client'

import { useContext, useState } from 'react'
import { IconTrashX } from '@tabler/icons-react'
import { useSession } from 'next-auth/react'

import { ProductSeoStorage } from 'shared/analytics'
import Button from 'shared/ui/Button'
import { ButtonVariants } from 'shared/ui/Button/Button.enums'
import { Modal, ModalDescription, ModalTitle } from 'shared/ui/Modal'
import {
  OfflineContext,
  OfflineContextType
} from 'shared/ui/Offline/OfflineContext'
import toast from 'shared/ui/utils/toast'

import useCartStore from '../../../store/cartStore'

import styles from './ClearCartModal.module.scss'

const ClearCartModal = () => {
  const session = useSession()
  const [open, setOpen] = useState(false)
  const { cart, clearCart } = useCartStore()
  const { isOnline, temporaryOfflineNotificationError } = useContext(
    OfflineContext
  ) as OfflineContextType

  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  const handleSubmit = async () => {
    if (isOnline) {
      await clearCart(session, cart?.id)
      ProductSeoStorage.clear()
      toast.success('Koszyk wyczyszczony')
      handleClose()
    } else {
      temporaryOfflineNotificationError()
    }
  }

  return (
    <>
      <Button
        className={styles.clearCartButton}
        variant={ButtonVariants.neutralText}
        onClick={handleOpen}
        startIcon={<IconTrashX />}
        disabled={(cart?.items?.length || 0) < 1}
        id='clear_cart_button'
      >
        Wyczyść koszyk
      </Button>
      <Modal
        id='clear-cart-confirmation-modal'
        open={open}
        onClose={handleClose}
      >
        <ModalTitle>Wyczyść koszyk</ModalTitle>
        <ModalDescription>
          Czy na pewno chcesz wyczyścić swój koszyk?
        </ModalDescription>
        <div className={styles.buttonsWrapper}>
          <Button fullWidth variant='neutralOutline' onClick={handleClose}>
            Anuluj
          </Button>
          <Button
            fullWidth
            variant='primary'
            onClick={handleSubmit}
            id='clear_cart_modal_submit_button'
          >
            Wyczyść
          </Button>
        </div>
      </Modal>
    </>
  )
}

export default ClearCartModal
